import { render, staticRenderFns } from "./SmsModelEdit.vue?vue&type=template&id=54b91cf8"
import script from "./SmsModelEdit.vue?vue&type=script&lang=js"
export * from "./SmsModelEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports